import { PDFViewer } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import GoodsIssuedPDF from '../pdf/GoodsIssuedPDF';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ViewGoodsIssuedPDFModal = ({ isOpen, closeModal, data, title, tenant_info }) => {

 const [page_data, setPageData] = useState(data);
 const [open, setOpen] = useState(isOpen);

 useEffect(() => {
  setPageData(data);
  setOpen(isOpen);
 }, [data, isOpen]);

 return (
  <>
   <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"xl"}>
    <ModalHeader toggle={closeModal}>{title}</ModalHeader>
    <ModalBody>
     {
      page_data && page_data?.length && (
       <>
        <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
         <PDFViewer height="100%" width="100%" showToolbar>
          <GoodsIssuedPDF page_data={page_data} tenant_info={tenant_info} />
         </PDFViewer>
        </div>
       </>
      )
     }
    </ModalBody>
   </Modal>
  </>
 );
};

export default ViewGoodsIssuedPDFModal;